import {Collection, collectionsQueryOptions} from '@blesk-frontend/api';
import {Loader, Page, PageTitle, Pagination, Topbar} from '@blesk-frontend/ui';
import {useQuery} from '@tanstack/react-query';
import {useSearch} from '@tanstack/react-router';

import {FeedbackButton} from '@/components';
import {ChangedTeamHint, TeamInviteButton} from '@/features/team';

import {CollectionCard, CollectionCreateButton, EmptyCollectionsCard} from '../components';

const RenderGrid = ({collections}: {collections: Collection[]}) => (
  <div className="grid flex-1 auto-rows-max gap-6 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
    {collections.map((collection) => (
      <CollectionCard key={collection.id} collection={collection} />
    ))}
  </div>
);

export const CollectionsPage = () => {
  const search = useSearch({from: '/_app/collections/'});

  const {data: collections, isLoading: isCollectionsLoading} = useQuery(
    collectionsQueryOptions({page: search.page || 1, take: 20, sort: 'updatedAt'}),
  );

  if (!isCollectionsLoading && !collections?.data.length) {
    return (
      <Page className="flex h-full flex-col">
        <div className="transition-all">
          <Topbar variant="sticky">
            <div className="flex h-10 gap-4">
              <FeedbackButton />
            </div>
            <div className="ml-auto flex h-10 gap-4">
              <TeamInviteButton />
            </div>
          </Topbar>
        </div>
        <ChangedTeamHint />
        <div className="mx-auto flex size-full max-w-screen-xl items-center justify-center">
          <EmptyCollectionsCard />
        </div>
      </Page>
    );
  }

  return (
    <Page className="flex h-full flex-col">
      <div className="transition-all">
        <Topbar variant="sticky">
          <div className="flex h-10 gap-4">
            <FeedbackButton />
          </div>
          <div className="ml-auto flex h-10 gap-4">
            <TeamInviteButton />
            <CollectionCreateButton />
          </div>
        </Topbar>
      </div>

      <div className="container mx-auto flex h-full max-w-screen-xl flex-col gap-8">
        <PageTitle>
          <span>Коллекции</span>
        </PageTitle>

        <ChangedTeamHint />

        {isCollectionsLoading ? (
          <div className="my-auto flex items-center justify-center text-text-disabled">
            <Loader size={32} />
          </div>
        ) : (
          <RenderGrid collections={collections?.data || []} />
        )}

        {collections?.pagination && <Pagination pagination={collections?.pagination} />}
      </div>
    </Page>
  );
};
